import useFormControl from './useFormControl';

// export types
export type { UseFormControlProps } from './useFormControl';

// export hooks
export { useFormControl };
export default useFormControl;
